import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Консультація',
  description: 'Аналізуємо вашу ситуацію, визначаємо перспективи справи та розробляємо чіткий план дій. Ви розумієте всі ризики та можливості.'
}, {
  num: '02',
  title: 'Підготовка',
  description: 'Я самостійно збираю необхідні докази, складаю позовну заяву та інші процесуальні документи. Від вас — мінімум зусиль.'
}, {
  num: '03',
  title: 'Суд без вас',
  description: 'Представляю ваші інтереси в суді. Вам не потрібно бачитись з колишнім партнером або витрачати час на засідання.'
}, {
  num: '04',
  title: 'Результат',
  description: 'Отримуєте готове рішення суду, яке набрало законної сили. Справа вирішена.'
}];
export function Process() {
  return <section id="process" className="py-32 bg-neutral-50 text-neutral-900" data-id="element-118">
      <div className="container mx-auto px-6" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-24" data-id="element-120">
          <h2 className="text-4xl md:text-5xl font-normal tracking-tight mb-6" data-id="element-121">
            Прозорий <span className="font-semibold" data-id="element-122">процес</span>
          </h2>
          <p className="text-xl text-neutral-600 font-normal max-w-2xl" data-id="element-123">
            Чотири прості кроки до вирішення вашої проблеми.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8" data-id="element-124">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="relative" data-id="element-125">
              <div className="text-6xl font-normal text-neutral-200 mb-8" data-id="element-126">
                {step.num}
              </div>
              <h3 className="text-2xl font-semibold mb-4" data-id="element-127">{step.title}</h3>
              <p className="text-neutral-600 leading-relaxed font-normal" data-id="element-128">
                {step.description}
              </p>

              {/* Connector line */}
              {idx < steps.length - 1 && <div className="hidden md:block absolute top-8 left-[80%] w-[80%] h-[1px] bg-neutral-200" data-id="element-129" />}
            </motion.div>)}
        </div>
      </div>
    </section>;
}